// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Toast container: fixed placement, responsive */
.toast-container {
  position: fixed;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 12px;
  pointer-events: none;
  padding: 16px;
  max-width: min(400px, calc(100vw - 32px));
}

/* Web: bottom-right */
@media (min-width: 769px) {
  .toast-container {
    bottom: 24px;
    right: 24px;
    left: auto;
    top: auto;
    align-items: flex-end;
  }
}

/* Mobile: top-center, below typical topbar */
@media (max-width: 768px) {
  .toast-container {
    top: 72px;
    left: 50%;
    right: auto;
    bottom: auto;
    transform: translateX(-50%);
    align-items: center;
    padding: 12px 16px;
  }
}

/* Single toast */
.toast {
  pointer-events: auto;
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  border-radius: 8px;
  box-shadow: var(--shadow-lg);
  background-color: var(--color-white);
  border: 1px solid var(--color-light-gray);
  animation: toast-in 0.25s ease-out;
}

@media (max-width: 768px) {
  .toast {
    padding: 12px 16px;
    border-radius: 8px;
    width: 100%;
    max-width: min(400px, calc(100vw - 32px));
  }
}

@keyframes toast-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (min-width: 769px) {
  @keyframes toast-in {
    from {
      opacity: 0;
      transform: translateX(8px);
    }
    to {
      opacity: 1;
      transform: translateX(0);
    }
  }
}

.toast-icon {
  flex-shrink: 0;
  margin-top: 2px;
}

.toast-message {
  flex: 1;
  min-width: 0;
}

/* Success variant */
.toast--success {
  background-color: var(--color-pastelle-blue);
  border-color: var(--color-light-green);
}

.toast--success .toast-message {
  color: var(--color-dark-green);
}

/* Extendable: error variant (for future use) */
.toast--error {
  background-color: var(--color-pastelle-red);
  border-color: var(--color-warning-red);
}

.toast--error .toast-message {
  color: var(--color-black);
}

/* Extendable: info variant (for future use) */
.toast--info {
  background-color: var(--color-pastelle-gray);
  border-color: var(--color-gray);
}

.toast--info .toast-message {
  color: var(--color-black);
}
`, "",{"version":3,"sources":["webpack://./src/components/Toast/Toast.css"],"names":[],"mappings":"AAAA,iDAAiD;AACjD;EACE,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,aAAa;EACb,yCAAyC;AAC3C;;AAEA,sBAAsB;AACtB;EACE;IACE,YAAY;IACZ,WAAW;IACX,UAAU;IACV,SAAS;IACT,qBAAqB;EACvB;AACF;;AAEA,6CAA6C;AAC7C;EACE;IACE,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;EACpB;AACF;;AAEA,iBAAiB;AACjB;EACE,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,kBAAkB;EAClB,4BAA4B;EAC5B,oCAAoC;EACpC,yCAAyC;EACzC,kCAAkC;AACpC;;AAEA;EACE;IACE,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,yCAAyC;EAC3C;AACF;;AAEA;EACE;IACE,UAAU;IACV,0BAA0B;EAC5B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE;MACE,UAAU;MACV,0BAA0B;IAC5B;IACA;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;AACF;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA,oBAAoB;AACpB;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,8BAA8B;AAChC;;AAEA,+CAA+C;AAC/C;EACE,2CAA2C;EAC3C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,8CAA8C;AAC9C;EACE,4CAA4C;EAC5C,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["/* Toast container: fixed placement, responsive */\n.toast-container {\n  position: fixed;\n  z-index: 9999;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  pointer-events: none;\n  padding: 16px;\n  max-width: min(400px, calc(100vw - 32px));\n}\n\n/* Web: bottom-right */\n@media (min-width: 769px) {\n  .toast-container {\n    bottom: 24px;\n    right: 24px;\n    left: auto;\n    top: auto;\n    align-items: flex-end;\n  }\n}\n\n/* Mobile: top-center, below typical topbar */\n@media (max-width: 768px) {\n  .toast-container {\n    top: 72px;\n    left: 50%;\n    right: auto;\n    bottom: auto;\n    transform: translateX(-50%);\n    align-items: center;\n    padding: 12px 16px;\n  }\n}\n\n/* Single toast */\n.toast {\n  pointer-events: auto;\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: var(--shadow-lg);\n  background-color: var(--color-white);\n  border: 1px solid var(--color-light-gray);\n  animation: toast-in 0.25s ease-out;\n}\n\n@media (max-width: 768px) {\n  .toast {\n    padding: 12px 16px;\n    border-radius: 8px;\n    width: 100%;\n    max-width: min(400px, calc(100vw - 32px));\n  }\n}\n\n@keyframes toast-in {\n  from {\n    opacity: 0;\n    transform: translateY(8px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@media (min-width: 769px) {\n  @keyframes toast-in {\n    from {\n      opacity: 0;\n      transform: translateX(8px);\n    }\n    to {\n      opacity: 1;\n      transform: translateX(0);\n    }\n  }\n}\n\n.toast-icon {\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.toast-message {\n  flex: 1;\n  min-width: 0;\n}\n\n/* Success variant */\n.toast--success {\n  background-color: var(--color-pastelle-blue);\n  border-color: var(--color-light-green);\n}\n\n.toast--success .toast-message {\n  color: var(--color-dark-green);\n}\n\n/* Extendable: error variant (for future use) */\n.toast--error {\n  background-color: var(--color-pastelle-red);\n  border-color: var(--color-warning-red);\n}\n\n.toast--error .toast-message {\n  color: var(--color-black);\n}\n\n/* Extendable: info variant (for future use) */\n.toast--info {\n  background-color: var(--color-pastelle-gray);\n  border-color: var(--color-gray);\n}\n\n.toast--info .toast-message {\n  color: var(--color-black);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
